export enum AlbLaceStyle {
  Insert = 'insert',
  Full = 'full',
}

export enum AlbLaceOption {
  JhsInsert = 'jhs_insert',
  AlphaOmegaInsert = 'alpha_omega_insert',
  CrossDesignInsert = 'cross_design_insert',
  MarianDesignInsert = 'marian_design_insert',
  Jhs = 'jhs',
  MarianDesign = 'marian_design',
  AlphaOmegaDesign = 'alpha_omega_design',
  Long = 'long',
}
